<template>
  <el-select
    v-model="data"
    filterable
    remote
    reserve-keyword
    placeholder="请输入关键词"
    :remote-method="onSearch"
    @focus="onFocus"
    @clear="onClear"
    @blur="onBlur"
    clearable
    :loading="loading">
    <el-option
      v-for="(option,index) in list"
      @click.native="onClick(option,index)"
      :class="value[keyLabel] == option[keyLabel] ? 'selected hover' : ''"
      :label="option[keyLabel]"
      :value="option[keyValue]" :key="index">
    </el-option>
    <div style="position: relative">
      <div class="cus-auto-body-more" @click="onMore" v-if="!loading && !finished">查看更多</div>
      <div class="cus-auto-body-more" v-if="list.length && finished">没有更多啦~</div>
    </div>
  </el-select>
</template>

<script>

  export default {
    data() {
      return {
        data: '',
        loading: true,
        finished: false,
        pages: {
          page: 1,
          pageSize: 10
        },
        tempList: [],
        list: []
      }
    },
    watch: {
      value: {
        handler (val) {
          this.data = val[this.keyLabel]
        },
        immediate: true,
        deep: true
      }
    },
    props: {
      value: {
        type: Object,
        default: () => {
          return {
            label: '',
            value: ''
          }
        }
      },
      fnc: {
        type: Function,
        default: () => {
          return () => {
          }
        }
      },
      fncLabel: {
        type: [String],
        default: 'name'
      },
      keyLabel: {
        type: [String, Number],
        default: 'label'
      },
      keyValue: {
        type: [String, Number],
        default: 'value'
      },
      cusParams: {
        type: Object,
        default: () => {
          return {}
        }
      },
      returnLabel: {
        type: String,
        default: 'result'
      }
    },
    mounted() {
      if (this.data && this.value[this.keyValue]) this.data = this.value[this.keyLabel]
    },
    methods: {
      onReset() {
        return new Promise(resolve => {
          this.list = []
          this.pages.page = 1
          this.pages.pageSize = 10
          this.loading = true
          this.finished = false;
          resolve()
        })
      },
      onSearch(query) {
        this.data = query;
        this.$cu.debounce(() => {
          this.onReset().then(() => this.getOptionsList(query));
        })
      },
      onMore() {
        this.loading = true
        this.getOptionsList()
      },
      onBlur () {
        if (this.data && this.value[this.keyValue]) this.data = this.value[this.keyLabel]
        if (!this.value[this.keyLabel] && !this.list.length && !this.list.filter(v => { v[this.keyValue] == this.value[this.keyValue] }).length) {
          this.data = '';
          this.onReset();
        }
      },
      onClick(option, index) {
        this.$emit('update:value', Object.assign(this.value, {
          [this.keyLabel]: option[this.keyLabel],
          [this.keyValue]: option[this.keyValue]
        }))
        this.$emit('onChange', option, index)
        this.data = option[this.keyLabel]
      },
      onClear(){
        if (!this.value[this.keyLabel]) return
        this.$emit('update:value', Object.assign(this.value, {
          [this.keyLabel]: '',
          [this.keyValue]: ''
        }))
        this.data = ''
        this.onReset();
      },
      onFocus() {
        if ((!this.value[this.keyValue] && this.list.length) || this.finished) return;
        this.onReset().then(() => this.getOptionsList());
      },
      getOptionsList() {
        return new Promise(resolve => {
          let params = {
            [this.fncLabel]: this.data,
            currentPage: this.pages.page,
            pageSize: this.pages.pageSize,
          }
          Object.assign(params, this.cusParams)
          this.fnc(params).then(res => {
            this.loading = false;
            if (res.code === 1) {
              this.pages.page += 1
              this.list = this.list.concat(res[this.returnLabel].list)
              if (res[this.returnLabel].list.length < this.pages.pageSize) this.finished = true
              resolve()
            }
          })
        })
      }
    }
  }
</script>

<style scoped>
  .cus-auto-body-more {
    color: #3399ff;
    text-align: center;
    font-size: 12px;
    height: 32px;
    padding-top: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .cus-auto-body-more:hover {
    color: #5cadff;
  }
</style>



// WEBPACK FOOTER //
// src/cuview-ui/components/cus-autoComplete/cus-autoComplete.vue